export default __webpack_public_path__ + "static/media/pals_bandana_mockup.440997c6.png";